/* nt-fx-g3.js: avaliacoes e veja em acao da home nova.
   o leitor, o ampliar e as abas das avaliacoes vem do nt-fx-avaliacoes.js (copia do script do
   nt-reviews) e as paginas do elemento nt-reviews (nt-sections.js); aqui fica so o que a roupa nova pede.
   o arquivo pode vir mais de uma vez na pagina: cada peca e ligada uma vez so. */
(function () {
  'use strict';

  var calmo = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- avaliacoes ---------- */
  function ligarAvaliacoes(sec) {
    if (sec.dataset.g3Ligado) return;
    sec.dataset.g3Ligado = '1';

    /* "ler mais" so quando o texto passa das linhas visiveis. cartao escondido pela pagina mede zero,
       entao a conta e refeita a cada pagina que o nt-reviews pinta */
    var quadro = 0;
    function marcar() {
      quadro = 0;
      sec.querySelectorAll('.s-aval__cartao').forEach(function (c) {
        if (c.hidden || !c.offsetParent) return;
        var t = c.querySelector('.s-aval__texto');
        if (!t) { c.removeAttribute('data-corta'); return; }
        if (t.scrollHeight > t.clientHeight + 2) c.setAttribute('data-corta', '');
        else c.removeAttribute('data-corta');
      });
    }
    function agendar() { if (!quadro) quadro = window.requestAnimationFrame(marcar); }
    sec.addEventListener('nt-rev-render', agendar);
    window.addEventListener('resize', agendar, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(agendar);
    agendar();

    /* abas: o clique e do script do nt-reviews; aqui ficam as setas do teclado, o tab so na aba aberta
       e o painel apontando para a aba que o nomeia */
    var abas = Array.prototype.slice.call(sec.querySelectorAll('[data-nt-aba]'));
    var varal = sec.querySelector('.s-aval__varal');
    if (abas.length < 2) return;
    function acertar(aberta) {
      abas.forEach(function (a) { a.tabIndex = a === aberta ? 0 : -1; });
      if (varal && aberta.id) varal.setAttribute('aria-labelledby', aberta.id);
      agendar();
    }
    abas.forEach(function (aba, i) {
      aba.addEventListener('click', function () { acertar(aba); });
      aba.addEventListener('keydown', function (e) {
        var passo = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!passo) return;
        e.preventDefault();
        var alvo = abas[(i + passo + abas.length) % abas.length];
        alvo.focus();
        alvo.click();
      });
    });
  }

  /* ---------- veja em acao: videos sem som que tocam quando metade aparece ----------
     o botao pausa e retoma; pausado pela pessoa, o video nao volta sozinho. com movimento reduzido
     ficam parados no primeiro quadro ate a pessoa apertar o play */
  function ligarVideo(btn) {
    if (btn.dataset.g3Ligado) return;
    btn.dataset.g3Ligado = '1';
    var video = btn.parentNode.querySelector('video');
    if (!video) return;
    var nome = video.getAttribute('aria-label') || '';
    var pausa = btn.getAttribute('data-rotulo-pausa') || 'Pausar';
    var toca = btn.getAttribute('data-rotulo-toca') || 'Reproduzir';
    var pausadoPelaPessoa = calmo;
    function pintar() {
      var tocando = !video.paused;
      btn.classList.toggle('is-tocando', tocando);
      btn.setAttribute('aria-label', (tocando ? pausa : toca) + ' ' + nome);
    }
    video.addEventListener('play', pintar);
    video.addEventListener('pause', pintar);
    btn.addEventListener('click', function () {
      if (video.paused) { pausadoPelaPessoa = false; video.play().catch(function () {}); }
      else { pausadoPelaPessoa = true; video.pause(); }
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) {
        if (e[0].isIntersecting && !pausadoPelaPessoa) video.play().catch(function () {});
        else if (!e[0].isIntersecting) video.pause();
      }, { threshold: 0.5 }).observe(video);
    }
    pintar();
  }

  function ligar(raiz) {
    raiz.querySelectorAll('.s-aval').forEach(ligarAvaliacoes);
    raiz.querySelectorAll('.s-veja [data-g3-video]').forEach(ligarVideo);
  }
  ligar(document);
  document.addEventListener('shopify:section:load', function (e) { ligar(e.target); });
})();
